import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Form, Field } from 'react-final-form';
import { toast } from 'react-toastify';
import { useMediaQuery, Grid2, Button, InputAdornment, Tooltip, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { PaymentLinkModal, PhoneNumber, AlertDialog, SelectComponent, TextInput, CheckboxTerms, ExperienceAvailabilityLegacy } from '@utriper/core-ui';
import { formatCurrency, PaymentPlatform } from '@utriper/core';

import Layout from 'components/Layout';

import { useTranslation } from 'core/contexts/localization';
import { useAuth } from 'core/contexts/auth';
import { useExperiences } from 'core/contexts/experience';
import { useHost } from 'core/contexts/host';
import { useBookings } from 'core/contexts/booking';
import { useStripe } from 'core/contexts/stripe';

import { ScheduleService } from 'core/api/services/schedule';

import { formatMoney } from 'core/packages/format';

import { ROUTES } from 'core/routing/routes';

import { PaymentPlatformChips } from './components/PaymentPlatformChips';
import StripeForm from './components/StripeForm';
import Summary from './components/Summary';

const initialStateValues = {
    id: '',
    firstname: '',
    lastname: '',
    email: '',
    start: '',
    end: '',
    mobilePhone: undefined,
    quantity: 1,
    date: '',
    dateUTC: '',
    price: undefined,
    status: undefined,
    currency: 'COP',
    repeat: false,
    mobilePhoneCountryCode: '',
    paidPrice: undefined,
    arrivalTime: undefined,
    isArrivalTimeInRange: false,
    arrivalTimeFormatted: new Date(),
    hostName: '',
};

// TODO move this to libs
function isValidNumber(value) {
    return typeof value === 'number' && !isNaN(value);
}

const BookingNewPage = (props) => {
    const history = useHistory();
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const { t: translate, i18n } = useTranslation();
    const formEndRef = useRef(null);
    const scheduleEndRef = useRef(null);

    const { getUserInfoSync } = useAuth();
    const { contractExperiences, getContractExperiences, contractBundleExperiences, getContractBundleExperiences, timeOfArrival, setTimeOfArrival, getExperiencesTermsId } = useExperiences();
    const { contract, setContract, contracts, getContracts } = useHost();
    const { addContractBooking, addContractBookingPayment, deleteContractBookingPayment, checkoutItems, setCheckoutItems, addCheckoutItem, cancelStatusPaymentLink, notifyPaymentLink } = useBookings();
    const { stripePromise } = useStripe();
    const [onFirstCall, setOnFirstCall] = useState(true); // This is used when having an experience id on url
    const [selectedExperienceItem, setSelectedExperienceItem] = useState(null); // This is used to get the availability
    const [selectedItem, setSelectedItem] = useState(null); // This is used for the dropdown selection
    const [allExpAndBundles, setAllExpAndBundles] = useState([]); // This is used for dropdown display and selection
    const [checkoutId, setCheckoutId] = useState(0); // This is unique id creator

    const [values, setValues] = useState(initialStateValues);
    const [open, setOpen] = useState(false);

    const [openPaymentLinkDialog, setOpenPaymentLinkDialog] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [successOpen, setSuccessOpen] = useState(false);
    const [quantityOpen, setQuantityOpen] = useState(false);
    const [quantityOpenOneTime, setQuantityOpenOneTime] = useState(true);
    const [showErrorPrice, setShowErrorPrice] = useState(false);

    const [stripeOpen, setStripeOpen] = useState(false);
    const [stripeClientSecret, setStripeClientSecret] = useState(false);

    // REVIEW THIS
    // const [selectedSlotId, setSelectedSlotId] = useState(null);
    const [selectedSlotPrice, setSelectedSlotPrice] = useState(null);
    const [slotsVacancy, setSlotsVacancy] = useState([]);

    const [paymentPlatformId, setPaymentPlatformId] = useState(null);
    const [paymentId, setPaymentId] = useState(null);
    const [terminalPaymentId, setTerminalPaymentId] = useState(null);
    const [acceptedPaymentPlatforms, setAcceptedPaymentPlatforms] = useState([]);
    const [email, setEmail] = useState('');
    const [mobilePhone, setMobilePhone] = useState('');
    const today = new Date();
    const date = new Date(today.getTime() + 720 * 60000);

    const [bookingId, setBookingId] = useState(null);
    const [bookingCode, setBookingCode] = useState(null);
    const [payNowPrice, setPayNowPrice] = useState(null);
    const [payTotalPrice, setPayTotalPrice] = useState(null);
    const [currency, setCurrency] = useState(null);
    const [paymentLink, setPaymentLink] = useState(null);
    // ---
    const [isNotFirstCall, setIsNotFirstCall] = useState(true);
    const [loading, setLoading] = useState(false);
    const [schedule, setSchedules] = useState();
    const [quantity, setQuantity] = useState(1);
    const [totalPrice, setTotalPrice] = useState(0);
    const [visibleRange, setVisibleRange] = useState({ start: null, end: null });
    const [dateDatePicker, setDateDatePicker] = useState(new Date());
    const [termsToAccept, setTermsToAccept] = useState(null);
    const [agreeWithTermsAndConditions, setAgreeWithTermsAndConditions] = useState(false);
    const [experienceDetailOptions, setExperienceDetailOptions] = useState([]);
    const [experienceDetail, setExperienceDetail] = useState(null);

    // UNTIL HERE

    // Get url params
    const { id } = useParams();
    const expIndex = parseInt(id || 0);

    useEffect(() => {
        getUserInfoSync().then(async (usr) => {
            if (usr.host) {
                setAcceptedPaymentPlatforms(usr.host.acceptedPaymentPlatforms);
            }
            if (!contract || !contract.id) {
                const contracts = await getContracts();
                if (contracts && contracts.length) {
                    await getContractExperiences(contracts[0].id);
                    await getContractBundleExperiences(contracts[0].id);
                }
            } else {
                await getContractExperiences(contract.id);
                await getContractBundleExperiences(contract.id);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!contract || !contract.id) {
            getContracts().then((contracts) => {
                if (contracts && contracts.length) {
                    getContractExperiences(contracts[0].id);
                    getContractBundleExperiences(contracts[0].id);
                }
            });
        } else {
            getContractExperiences(contract.id);
            getContractBundleExperiences(contract.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contract]);

    useEffect(() => {
        if (onFirstCall) {
            const auxCheckout = [];
            setCheckoutItems(auxCheckout);
            setTimeOfArrival(null);
            setSelectedSlotPrice(null);
            setSelectedItem(null);
            setSelectedExperienceItem(null);
        }

        const allExp = [];
        let uniqueId = 0;
        if (contractExperiences && contractExperiences.length) {
            contractExperiences.forEach((exp) => {
                allExp.push({ ...exp, experienceId: exp.id, id: uniqueId });
                if (expIndex === exp.id && onFirstCall) {
                    setOnFirstCall(false);
                    let auxChkId = checkoutId;
                    exp.checkoutId = auxChkId;
                    exp.experienceId = exp.id;
                    exp.id = uniqueId;
                    setSelectedExperienceItem({ ...exp });
                    setSelectedItem(uniqueId);
                    const auxCheckout = checkoutItems;
                    auxCheckout.push(exp);
                    setCheckoutItems(auxCheckout);
                    auxChkId++;
                    setCheckoutId(auxChkId);
                }
                uniqueId++;
            });
        }
        if (contractBundleExperiences && contractBundleExperiences.length) {
            contractBundleExperiences.forEach((bld) => {
                bld.experiences?.forEach((exp) => {
                    exp.expDetailId = exp.experienceDetailId || exp?.expDetailId;
                    exp.experienceId = exp.expId;
                    exp.id = uniqueId;
                    uniqueId++;
                });
                allExp.push({
                    ...bld,
                    name: `${translate('global_bookings.bundle')}: ${bld.name}`,
                    bundleId: bld.id,
                    id: uniqueId,
                });
                uniqueId++;
            });
        }
        setAllExpAndBundles(allExp);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractExperiences, contractBundleExperiences]);

    const getEvents = () => {
        if (!selectedExperienceItem || !Date.parse(visibleRange.start) || !Date.parse(visibleRange.end)) {
            return;
        }
        setLoading(true);
        ScheduleService.getAvailability({
            expId: selectedExperienceItem.experienceId,
            experienceDetailId: experienceDetail?.id ?? null,
            fromDateTime: new Date(visibleRange.start),
            toDateTime: new Date(visibleRange.end),
            groupSize: quantity,
            code: contract.id.toString(16),
        }).then((res) => {
            setSchedules([...res]);
            setLoading(false);
        });
    };
    useEffect(() => {
        getEvents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedExperienceItem, quantity, experienceDetail]);
    useEffect(() => {
        if (!selectedExperienceItem) {
            return;
        }

        if (isNotFirstCall || (Date.parse(visibleRange.start) && Date.parse(visibleRange.end) && !(visibleRange.start.getTime() < dateDatePicker.getTime() && visibleRange.end.getTime() > dateDatePicker.getTime()))) {
            setIsNotFirstCall(false);
            getEvents();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateDatePicker, visibleRange]);

    useEffect(() => {
        const auxCheckout = checkoutItems.map((it) => {
            if (it.checkoutId === selectedExperienceItem?.checkoutId) {
                it.dateUTC = timeOfArrival?.dateUTC;
                it.timezone = timeOfArrival?.timezone;
                it.duration = timeOfArrival?.duration;
            }
            if (it.bundleId) {
                it.experiences?.forEach((itExp) => {
                    if (itExp.checkoutId === selectedExperienceItem?.checkoutId) {
                        itExp.dateUTC = timeOfArrival?.dateUTC;
                        itExp.timezone = timeOfArrival?.timezone;
                        it.duration = timeOfArrival?.duration;
                    }
                });
            }
            return { ...it };
        });
        setCheckoutItems(auxCheckout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeOfArrival]);

    useEffect(() => {
        if (!isValidNumber(selectedSlotPrice)) {
            return;
        }
        const auxPrice = selectedSlotPrice;
        setSelectedSlotPrice(null);
        const auxCheckout = checkoutItems.map((it) => {
            if (it.checkoutId === selectedExperienceItem?.checkoutId) {
                it.slotPrice = auxPrice;
            }
            if (it.bundleId) {
                it.experiences?.forEach((itExp) => {
                    if (itExp.checkoutId === selectedExperienceItem?.checkoutId) {
                        itExp.slotPrice = auxPrice;
                    }
                });
            }
            return { ...it };
        });
        setCheckoutItems(auxCheckout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSlotPrice]);

    //check if there's overbooking
    const checkOverbooking = () => {
        const slotsGroupedById = Object.groupBy(slotsVacancy, (slot) => slot.slotId);
        const arrayOfSlots = Object.values(slotsGroupedById);
        for (let i = 0; i < arrayOfSlots.length; i++) {
            const itemsOnSlot = arrayOfSlots[i];
            let count = 0;
            for (let j = 0; j < itemsOnSlot.length; j++) {
                count += itemsOnSlot[j].numberOfBookings;
            }
            if (count > itemsOnSlot[0].vacancies) {
                toast.error(` ${translate('global_bookings.errors.overbooking')}. TOUR: ${itemsOnSlot[0].expName}. ${translate('global_bookings.errors.current_availability')}: ${itemsOnSlot[0].vacancies} ${translate('global_bookings.people')}`, {
                    position: 'top-center',
                    theme: 'colored',
                });
                setCheckoutItems((prev) => {
                    const updatedItems = prev.slice(0, -1);
                    return updatedItems;
                });
                setSlotsVacancy((prev) => {
                    const updatedItems = prev.slice(0, -1);
                    return updatedItems;
                });
            }
        }
    };
    useEffect(() => {
        if (slotsVacancy.length > 0) {
            checkOverbooking();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slotsVacancy]);

    const handleDatePickerChange = (date) => {
        setDateDatePicker(date);
        setTimeOfArrival(null);
    };

    useEffect(() => {
        let changeSummary = false;
        setSlotsVacancy((prev) => {
            return prev.filter((slot) => slot.checkoutId !== selectedExperienceItem.checkoutId);
        });
        const auxCheckoutItems = checkoutItems.map((it) => {
            if (it.bundleId) {
                it.experiences?.forEach((exp) => {
                    if (exp.dateUTC) {
                        delete exp.dateUTC;
                        changeSummary = true;
                    }
                });
            } else {
                if (it.dateUTC) {
                    delete it.dateUTC;
                    changeSummary = true;
                }
            }
            return it;
        });
        if (changeSummary) {
            setCheckoutItems(auxCheckoutItems);
            setQuantityOpen(true);
        }
        const auxValues = {
            ...values,
            quantity,
        };
        setValues(auxValues);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quantity]);

    const isPaymentPlatformAllowed = (id) => {
        if (!acceptedPaymentPlatforms || !acceptedPaymentPlatforms.length) {
            return false;
        }
        return acceptedPaymentPlatforms.some((method) => method.id === id);
    };

    const handleSubmit = async (e) => {
        if (totalPrice < 0 && !paymentPlatformId && parseFloat(selectedSlotPrice) !== 0) {
            setAlertOpen(true);
            return;
        }

        const data = {
            email: values.email,
            firstName: values.firstname,
            lastName: values.lastname,
            quantity: values.quantity,
            status: values.status,
            mobilePhone: values.mobilePhone,
            mobilePhoneCountryCode: values.mobilePhoneCountryCode,
            hostName: values.hostName,
            code: contract?.id || null,
            paymentPlatform: paymentPlatformId,
            items: checkoutItems,
        };

        const { bookingId, bookingCode, paymentId, payNow, payTotal, currency, clientSecret, paymentLink, termsToAccept } = await addContractBooking(data.experienceId, data.expDetailId, data);

        if (!bookingId) {
            toast.error(translate('global_bookings.errors.add_booking'), {
                position: 'top-right',
                theme: 'colored',
            });
            const auxCheckout = [];
            setCheckoutItems(auxCheckout);
            history.push(ROUTES.BOOKINGS);
        } else {
            if (parseInt(paymentPlatformId) === PaymentPlatform.IDS.link && paymentLink) {
                setPaymentLink(paymentLink);
            }

            setBookingId(bookingId);
            setBookingCode(bookingCode);
            setPaymentId(paymentId);
            setPayNowPrice(payNow);
            setPayTotalPrice(payTotal);
            setTermsToAccept(termsToAccept);

            setCurrency(currency);
            if (parseFloat(payNow) > 0) {
                if (paymentPlatformId === PaymentPlatform.IDS.stripe) {
                    setStripeClientSecret(clientSecret);
                    setStripeOpen(true);
                } else if (paymentPlatformId === PaymentPlatform.IDS.link) {
                    setOpenPaymentLinkDialog(true);
                } else {
                    setOpen(true);
                }
            } else {
                if (paymentPlatformId === PaymentPlatform.IDS.link) {
                    setOpenPaymentLinkDialog(true);
                } else {
                    setSuccessOpen(true);
                }
            }
        }
    };

    const required = (value) => {
        return value ? undefined : translate('form.required');
    };

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
            id: expIndex,
        });
    };

    const onSubmitConfirmPayment = async (e) => {
        let hideUID = false;
        if (parseInt(paymentPlatformId) === PaymentPlatform.IDS.cash) {
            hideUID = true;
        }

        if (!terminalPaymentId && !hideUID) {
            return;
        }

        let termsAccepted = [];

        if (termsToAccept?.length && agreeWithTermsAndConditions) {
            termsAccepted = [...termsToAccept];
        }

        await addContractBookingPayment({
            paymentId,
            paymentUID: terminalPaymentId,
            status: 'approved',
            statusId: 3,
            termsAccepted,
        });
        setSuccessOpen(true);
    };

    const onSubmitConfirmPaymentLink = async (values) => {
        if (parseInt(paymentPlatformId) !== PaymentPlatform.IDS.link || !bookingId) {
            return;
        }

        const result = await notifyPaymentLink({
            email: values.email,
            mobilePhone: values.mobilePhone,
            expiryDate: values.expiryDay,
            bookingId,
        });

        if (result) {
            setSuccessOpen(true);
        }
    };

    const cancelPaymentLinkModal = async (e) => {
        // Call api to change status
        await cancelStatusPaymentLink({ paymentLink });
    };

    const onDismissConfirmPayment = async (e) => {
        // Call api to delete payment initiation
        if (!paymentId) {
            return;
        }
        await deleteContractBookingPayment({ paymentId });
    };

    const renderBookingForm = () => {
        return (
            <>
                <Form
                    onSubmit={handleSubmit}
                    initialValues={{ ...values }}
                    render={({ handleSubmit, values }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            {/* FORM ROWS */}
                            <Grid2 container spacing={2} direction="row" justifyContent="space-between" alignItems="center" style={{ flexDirection: 'row', width: '100%', flexWrap: 'wrap' }}>
                                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                    <Field
                                        style={{
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                        }}
                                        required
                                        validate={required}
                                        // className="add-experience__capacity"
                                        variant="outlined"
                                        label={translate('bookingForm.firstname')}
                                        name="firstname"
                                        value={values.firstName}
                                        onTextFieldChange={handleInputChange}
                                        component={TextInput}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                    <Field
                                        style={{
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                        }}
                                        required
                                        validate={required}
                                        // className="add-experience__capacity"
                                        variant="outlined"
                                        label={translate('bookingForm.lastname')}
                                        name="lastname"
                                        value={values.lastName}
                                        onTextFieldChange={handleInputChange}
                                        component={TextInput}
                                    />
                                </Grid2>
                            </Grid2>
                            {/* </div> */}
                            <Grid2 container spacing={2} direction="row" justifyContent="space-between" alignItems="center" style={{ flexDirection: 'row', width: '100%', flexWrap: 'wrap' }}>
                                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                    <Field
                                        style={{
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                        }}
                                        required
                                        validate={(email) => {
                                            if (!email) {
                                                return translate('form.required');
                                            }
                                            if (!validateEmail(email)) {
                                                return translate('form.invalid.email');
                                            }
                                            return undefined;
                                        }}
                                        // className="add-experience__capacity"
                                        variant="outlined"
                                        label="Email"
                                        name="email"
                                        value={values.email}
                                        onTextFieldChange={(event) => {
                                            handleInputChange(event);
                                            setEmail(event?.target.value);
                                        }}
                                        component={TextInput}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                    <Field
                                        style={{
                                            marginTop: '15px',
                                            marginBottom: '15px',
                                        }}
                                        id="phone"
                                        onFieldChange={(value, country) => {
                                            const auxValues = {
                                                ...values,
                                                mobilePhone: value,
                                                mobilePhoneCountryCode: country,
                                            };
                                            setValues(auxValues);
                                            setMobilePhone(value);
                                        }}
                                        // className="add-experience__capacity"
                                        name="mobilePhone"
                                        component={PhoneNumber}
                                        hintText={translate('profile.phone')}
                                        label={translate('bookingForm.phone') + ' *'}
                                        initialCountry={'us'}
                                        validateField={(value, countryCode) => value.length > 0 && value.startsWith(countryCode) && value.length > countryCode.length}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
                                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                    <Field
                                        style={{
                                            marginTop: '15px',
                                            marginBottom: '15px',
                                        }}
                                        required
                                        validate={required}
                                        variant="outlined"
                                        label={translate('bookingForm.hostname')}
                                        name="hostName"
                                        value={values.hostName}
                                        onTextFieldChange={handleInputChange}
                                        component={TextInput}
                                        Input
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <Tooltip title={translate('bookingForm.hostnameHint')}>
                                                    <HelpOutlineIcon />
                                                </Tooltip>
                                            </InputAdornment>
                                        }
                                    />
                                </Grid2>
                            </Grid2>

                            {/* PAYMENT METHOS */}
                            {totalPrice > 0 && (
                                <Grid2 container direction="column" spacing={3} style={{ marginTop: '25px', marginBottom: '25px' }}>
                                    <Grid2 container justifyContent="center">
                                        <Typography gutterBottom variant="h3">
                                            {translate('global_bookings.payment_method')}
                                        </Typography>
                                    </Grid2>
                                    <Grid2 container spacing={2} justifyContent="center">
                                        <PaymentPlatformChips paymentPlatformId={paymentPlatformId} isPaymentPlatformAllowed={isPaymentPlatformAllowed} onClick={setPaymentPlatformId} />
                                    </Grid2>
                                </Grid2>
                            )}
                            {/* BUTTONS */}
                            <Grid2 container spacing={3} justifyContent="center" style={{ marginTop: '25px' }}>
                                <Grid2>
                                    <Button
                                        variant="contained"
                                        onClick={(event) => {
                                            const auxCheckout = [];
                                            setCheckoutItems(auxCheckout);
                                            history.push(ROUTES.BOOKINGS);
                                        }}
                                        type="button">
                                        {translate('trip.create.buttons.cancel')}
                                    </Button>
                                </Grid2>
                                <Grid2>
                                    <Button variant="contained" color="primary" disabled={showErrorPrice} type="submit">
                                        {translate('form.continue')}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </form>
                    )}
                />
                <AlertDialog
                    open={open}
                    dialogTitle={translate('global_bookings.booking_payment')}
                    dialogContent={renderPaymentDialog()}
                    hideActions={true}
                    style={{ paddingBottom: '10px' }}
                    handleClose={() => {
                        onDismissConfirmPayment();
                        setOpen(false);
                    }}
                    handleSubmit={onSubmitConfirmPayment}
                    labelBack="Cancel"
                    labelNext="Confirm"
                />
                <PaymentLinkModal
                    open={openPaymentLinkDialog}
                    setOpen={setOpenPaymentLinkDialog}
                    paymentData={{
                        payTotalPrice,
                        payNowPrice,
                        currency,
                    }}
                    initialValues={{
                        email,
                        mobilePhone,
                        expiryDay: date,
                    }}
                    onClose={() => {
                        cancelPaymentLinkModal();
                        setOpenPaymentLinkDialog(false);
                    }}
                    onSubmit={onSubmitConfirmPaymentLink}
                />
                <AlertDialog
                    open={alertOpen}
                    dialogTitle={translate('global_bookings.booking_payment')}
                    hideTitle={true}
                    dialogContent={translate('global_bookings.payment_method')}
                    handleClose={() => {
                        setAlertOpen(false);
                    }}
                    handleSubmit={() => setAlertOpen(false)}
                    labelBack="Cancel"
                    hideBack={true}
                    labelNext="Ok"
                />
                <AlertDialog
                    open={successOpen}
                    dialogTitle={translate('global_bookings.booking_confirmation')}
                    hideTitle={true}
                    dialogContent={`${translate('global_bookings.booking_success')} ${bookingCode}`}
                    handleClose={() => {
                        setSuccessOpen(false);
                        const auxCheckout = [];
                        setCheckoutItems(auxCheckout);
                        history.push(ROUTES.BOOKINGS);
                    }}
                    handleSubmit={() => {
                        setSuccessOpen(false);
                        const auxCheckout = [];
                        setCheckoutItems(auxCheckout);
                        history.push(`${ROUTES.BOOKINGS}/${bookingId || ''}`);
                    }}
                    labelBack="Cancel"
                    hideBack={true}
                    labelNext="Ok"
                />
                <AlertDialog
                    open={stripeOpen}
                    dialogTitle={translate('global_bookings.booking_confirmation')}
                    hideTitle={true}
                    dialogContent={<StripeForm open={stripeOpen} stripePromise={stripePromise} clientSecret={stripeClientSecret} />}
                    handleClose={() => {
                        // DELETE BOOKING!!!
                        // setExpToDelete(null);
                        onDismissConfirmPayment();
                        setStripeOpen(false);
                    }}
                    handleSubmit={() => {
                        // setSuccessOpen(false);
                        // const auxCheckout = [];
                        // setCheckoutItems(auxCheckout);
                        // history.push(`${ROUTES.BOOKINGS}/${bookingId || ''}`);
                    }}
                    labelBack="Cancel"
                    hideBack={false}
                    labelNext="Ok"
                    hideSubmit={true}
                />
            </>
        );
    };

    const renderPaymentDialog = () => {
        let hideUID = false;
        if (parseInt(paymentPlatformId) === PaymentPlatform.IDS.cash) {
            hideUID = true;
        }
        return (
            <div>
                <Grid2 container>
                    <Grid2 size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}> {translate('global_bookings.total_price')} </Grid2>
                    <Grid2 container justifyContent="flex-end" size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
                        {' '}
                        {currency} {formatMoney(payTotalPrice)}{' '}
                    </Grid2>
                </Grid2>
                <Grid2 container style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <Grid2 size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}> {translate('global_bookings.amount')} </Grid2>
                    <Grid2 container justifyContent="flex-end" size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
                        {' '}
                        {currency} {formatMoney(payNowPrice)}{' '}
                    </Grid2>
                </Grid2>
                <Grid2 container>
                    <Grid2 size={12}>
                        <Form
                            onSubmit={onSubmitConfirmPayment}
                            // initialValues={{ ...values }}
                            render={({ handleSubmit, values, form }) => (
                                <form
                                    onSubmit={handleSubmit}
                                    // noValidate
                                    style={isSmall ? { width: '80vw' } : { width: 'auto' }}>
                                    {!hideUID && (
                                        <Field
                                            required
                                            // validate={required}
                                            className="add-experience__capacity"
                                            variant="outlined"
                                            label={`${translate('global_bookings.payment_code', { platform: PaymentPlatform.getTranslatedName(PaymentPlatform.types, paymentPlatformId, i18n.language) })}`}
                                            name="paymentId"
                                            value={''}
                                            onTextFieldChange={(e) => {
                                                const { value } = e.target;
                                                setTerminalPaymentId(value);
                                            }}
                                            component={TextInput}
                                        />
                                    )}
                                    {termsToAccept?.length > 0 && (
                                        <Field
                                            checked={agreeWithTermsAndConditions}
                                            onChange={(value) => {
                                                setAgreeWithTermsAndConditions(value);
                                            }}
                                            name="termsAndConditions"
                                            component={CheckboxTerms}
                                            termsToAccept={termsToAccept}
                                            onTermsClick={getExperiencesTermsId}
                                            fileUrl={process.env.REACT_APP_CDN_URL}
                                        />
                                    )}
                                    <Grid2 container marginTop="1rem" paddingBottom="1rem" spacing={1} justifySelf="end">
                                        <Button
                                            variant="outlined"
                                            sx={{ fontWeight: 'bold' }}
                                            onClick={(e) => {
                                                onDismissConfirmPayment();
                                                setOpen(false);
                                            }}>
                                            {translate('profile.btn_cancel')}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            sx={{ color: 'white', fontWeight: 'bold' }}
                                            type="submit"
                                            disabled={!agreeWithTermsAndConditions && termsToAccept?.length > 0}
                                            onClick={(e) => {
                                                handleSubmit(e);
                                            }}>
                                            {translate('profile.btn_confirm')}
                                        </Button>
                                    </Grid2>
                                </form>
                            )}
                        />
                    </Grid2>
                </Grid2>
            </div>
        );
    };

    const formatExperienceItem = (experience) => {
        if (experience?.experienceDetails?.length > 0) {
            const expDetails = experience?.experienceDetails?.map((experienceDetail) => ({
                ...experienceDetail,
                name: `${experienceDetail?.description1} ${experienceDetail?.price && experienceDetail?.currency ? `- ${formatCurrency(experienceDetail.price, experienceDetail.currency, i18n.language)}` : ''}`,
            }));
            setExperienceDetailOptions(expDetails);
            setExperienceDetail(expDetails[0]);
        }
    };

    const handleSelectExperience = (e) => {
        const val = { ...e };
        let auxChkId = checkoutId;
        val.checkoutId = auxChkId;

        if (val.bundleId) {
            val.experiences.forEach((exp) => {
                auxChkId++;
                exp.checkoutId = auxChkId;
                exp.experienceDetails = exp?.expDetail;
                exp.price = exp?.price ? exp.price : exp?.defaultPrice ? exp.defaultPrice : exp?.expPrice ? exp.expPrice : 0;
                exp.currency = exp?.currency ? exp.currency : exp?.defaultCurrency ? exp.defaultCurrency : exp?.expCurrency ? exp.expCurrency : 'USD';
                exp.duration = exp?.duration ? exp.duration : exp?.defaultDuration ? exp.defaultDuration : exp?.expDuration ? exp.expDuration : 0;
                exp.totalPrice = exp?.price ? exp.price : exp?.defaultPrice ? exp.defaultPrice : exp?.expPrice ? exp.expPrice : 0;
                exp.originalPayNow = exp?.payNow;
            });
            const experience = { ...val?.experiences[0] };
            formatExperienceItem(experience);
            setSelectedExperienceItem(experience);
        } else {
            formatExperienceItem(val);
            setSelectedExperienceItem({ ...val });
        }
        setSelectedItem(val.id);
        const auxCheckout = [...checkoutItems, val];
        setCheckoutItems(auxCheckout);
        auxChkId++;
        setCheckoutId(auxChkId);
    };

    const renderColumn = (title, children) => {
        return (
            <div style={{ paddingRight: '2rem' }}>
                <h2>{title}</h2>
                {children}
            </div>
        );
    };

    return (
        <Layout contentClassName="content">
            <Grid2
                container
                style={{
                    padding: '1rem 4rem',
                    minWidth: '375px',
                    flexDirection: 'column',
                    display: 'flex',
                    alignItems: 'center',
                }}
                size={{ xs: 12, sm: 4, md: 6, lg: 6, xl: 6 }}>
                <Grid2 container style={{ maxHeight: '100%', flexDirection: 'row', width: '100%', flexWrap: 'wrap' }}>
                    <Grid2 size={6} style={{ marginBottom: '0.5rem' }} sx={{ fontSize: { xs: '7px', sm: '10px', md: '14px' } }}>
                        {renderColumn(translate('contractSelect.contract'), <SelectComponent id={'contract'} values={contracts} placeHolder={translate('contractSelect.contract')} onChange={(val) => setContract(val)} value={contract?.id || null} />)}
                    </Grid2>
                    <Grid2 size={6} style={{ marginBottom: '1rem' }} sx={{ fontSize: { xs: '7px', sm: '10px', md: '14px' } }}>
                        {renderColumn(translate('global_bookings.add_an_experience'), <SelectComponent id={'experience'} values={allExpAndBundles} onChange={handleSelectExperience} value={selectedItem} />)}
                    </Grid2>
                </Grid2>

                <Grid2 container style={{ flexDirection: 'row', width: '100%' }}>
                    <Grid2 size={{ xs: 12, md: 8 }} order={{ xs: 2, md: 1 }} style={{ padding: '1rem' }}>
                        {checkoutItems.length ? (
                            <>
                                <Grid2 style={{ marginBottom: '4rem' }}>
                                    <h2>{translate('global_bookings.booking_summary')}</h2>
                                    <Summary
                                        showErrorPrice={showErrorPrice}
                                        setShowErrorPrice={setShowErrorPrice}
                                        quantity={quantity}
                                        checkoutId={checkoutId}
                                        setCheckoutId={setCheckoutId}
                                        checkoutItems={checkoutItems}
                                        setCheckoutItems={setCheckoutItems}
                                        setSelectedExperienceItem={setSelectedExperienceItem}
                                        setSelectedItem={setSelectedItem}
                                        totalPrice={totalPrice}
                                        setTotalPrice={setTotalPrice}
                                        onChangeDate={(val) => {
                                            formatExperienceItem(val);
                                            setSlotsVacancy((prev) => {
                                                return prev.filter((slot) => slot.checkoutId !== val.checkoutId);
                                            });
                                            setSelectedExperienceItem({ ...val });
                                            const exist = allExpAndBundles.find((el) => el.id === val.id);
                                            if (exist) {
                                                setSelectedItem(val.id);
                                            }
                                        }}
                                        onRemoveItem={(val) => {
                                            setSlotsVacancy((prev) => {
                                                return prev.filter((slot) => slot.checkoutId !== val.checkoutId);
                                            });

                                            setSelectedExperienceItem(null);

                                            const auxCheckout = checkoutItems.filter((it) => {
                                                return it.checkoutId !== val.checkoutId;
                                            });
                                            setCheckoutItems(auxCheckout);
                                        }}
                                    />
                                </Grid2>
                                <Grid2 style={{ marginBottom: '1rem' }}>
                                    <h2>{translate('global_bookings.triper_information')}</h2>
                                    {renderBookingForm()}
                                </Grid2>
                            </>
                        ) : null}
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 4 }} order={{ xs: 1, md: 2 }} style={{ padding: '1rem', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        {selectedExperienceItem && (
                            <>
                                <Grid2 style={{ marginBottom: '1rem', width: 'fit-content' }}>
                                    {renderColumn(
                                        `${translate('global_bookings.pick_a_date')}`,
                                        <ExperienceAvailabilityLegacy
                                            showLoading={loading}
                                            showQuantity
                                            showPrice={false}
                                            showAvailability={true}
                                            quantity={quantity}
                                            datePicker={dateDatePicker}
                                            slots={schedule}
                                            experience={selectedExperienceItem}
                                            setQuantity={setQuantity}
                                            experienceDetailOptions={experienceDetailOptions}
                                            experienceDetail={experienceDetail?.id}
                                            setExperienceDetail={(expDetail) => {
                                                setExperienceDetail(expDetail);
                                                setCheckoutItems((prev) => {
                                                    return prev.map((booking) => {
                                                        if (booking.checkoutId === selectedExperienceItem.checkoutId) {
                                                            return { ...booking, expDetailId: expDetail.id };
                                                        }
                                                        return booking;
                                                    });
                                                });
                                            }}
                                            setDatePicker={(date) => {
                                                handleDatePickerChange(date);
                                            }}
                                            setVisibleRange={setVisibleRange}
                                            setSelectedSlot={(slot) => {
                                                setSlotsVacancy((prev) => {
                                                    return [
                                                        ...prev,
                                                        {
                                                            slotId: slot.id,
                                                            numberOfBookings: quantity,
                                                            vacancies: slot.vacancies,
                                                            expName: selectedExperienceItem.name,
                                                            checkoutId: selectedExperienceItem.checkoutId,
                                                        },
                                                    ];
                                                });

                                                setSelectedSlotPrice(parseFloat(slot.price));

                                                setTimeOfArrival({ dateUTC: slot.startUTC, timezone: slot.timezone, duration: slot.duration });
                                                addCheckoutItem(selectedExperienceItem, slot.price, quantity);
                                            }}
                                        />
                                    )}
                                    <div ref={scheduleEndRef} />
                                </Grid2>
                            </>
                        )}
                    </Grid2>
                </Grid2>
            </Grid2>
            <AlertDialog
                dialogTitle={translate('global_bookings.attention')}
                open={quantityOpen && quantityOpenOneTime}
                dialogContent={<Typography variant="h6">{translate('global_bookings.change_quantity')}</Typography>}
                hideBack={true}
                handleSubmit={(e) => {
                    setQuantity(quantity);
                    setQuantityOpen(false);
                    setQuantityOpenOneTime(false);
                }}
                labelNext={'OK'}
            />
            {/* This for the autoscrollin */}
            <div ref={formEndRef} />
        </Layout>
    );
};

export default BookingNewPage;
